// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z-BZ","name":"styles_name__2puDY","phone":"styles_phone__18uOt"};